import React from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import TopBar from './components/Overlays/TopBar';
import Home_page from './components/Page 1/Home_page';
import HowItWorks_page from './components/Page 2/HowItWorks_page';
import YourInfo_page from './components/Page 3/YourInfo_page';
import PropertyInfo_page from './components/Page 5/PropertyInfo_page';
import Discounts_page from './components/Page 9/Discounts_page';
import Coverages_page from './components/Page 6/Coverages_page';
import QuickQuoteReferal_page from './components/Page 7/QuickQuoteReferal_page';
import ThankYou_page from './components/Page 8/ThankYou_page';
import ScrollToTop from './components/Additional/ScrollToTop';
import MaintenancePage from './components/MaintenancePage';
import ToastWrapperContext from 'context/toast-context/ToastContext';

import './custom.css';

const App = () => {
	const appConfig = window.APP_CONFIG;
	localStorage.setItem('branding', appConfig.BRANDING);
	localStorage.setItem('brand_email', appConfig.CONFIRMATION_EMAIL);
	localStorage.setItem(
		'brand_email_no_quote',
		appConfig.CONFIRMATION_EMAIL_NO_QUOTE,
	);
	localStorage.setItem('business_source', appConfig.BUSINESS_SOURCE);
	localStorage.setItem('producer_code', appConfig.PRODUCER_CODE);
	localStorage.setItem('new_product_id_date', appConfig.NEW_PRODUCT_ID_DATE);

	if (appConfig.MAINTENANCE_MODE) {
		return <MaintenancePage />;
	}

	return (
		<ToastWrapperContext>
			<div>
				<Router basename={appConfig.BASE_URL}>
					<ScrollToTop />
					<TopBar />
					<Switch>
						<Route exact path="/">
							<Home_page />
						</Route>
						<Route exact path="/HowItWorks">
							<HowItWorks_page />
						</Route>
						<Route exact path="/YourInfo">
							<YourInfo_page />
						</Route>
						<Route exact path="/QuickQuoteReferal">
							<QuickQuoteReferal_page />
						</Route>
						<Route exact path="/PropertyInfo">
							<PropertyInfo_page />
						</Route>
						<Route exact path="/Discounts">
							<Discounts_page />
						</Route>
						<Route exact path="/Coverages">
							<Coverages_page />
						</Route>
						<Route exact path="/ThankYou">
							<ThankYou_page />
						</Route>
					</Switch>
				</Router>
			</div>
		</ToastWrapperContext>
	);
};

export default App;
